

export const DESCENDANT_ONLY_COLUMNS = ['entity', 'entityId'] as const
